import { render, staticRenderFns } from "./fieldDuration.vue?vue&type=template&id=509f0020"
import script from "./fieldDuration.vue?vue&type=script&lang=js"
export * from "./fieldDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports